import React from 'react';
import { DataTable } from '../../../../../ui';
import { getColumns } from './Functions';
import { useJobOpeningTab } from './Hooks';

interface IJobOpeningTabProps {
  searchTerm?: string;
}

export const JobOpeningTab = ({ searchTerm }: IJobOpeningTabProps) => {
  const {
    jobOpeningData,
    onPageChange,
    pageNumber,
    totalPages,
    loading,
    history,
    totalRecords,
  } = useJobOpeningTab(searchTerm);

  return (
    <div className='relative w-full'>
      <DataTable
          isLoading={loading}
          columns={getColumns}
          data={jobOpeningData}
          rowsPerPage={5}
          onPageChange={onPageChange}
          currentPage={pageNumber}
          totalPages={totalPages}
          onClickRow={(row) => {
            history.push(`/job-openings/${row['id']}`);
          }}
          totalRecords={totalRecords}
      />
    </div>
  );
};
